// tslint:disable
/**
 * TC API
 * TestCollab is a test management tool that helps development teams carry out testing effectively and avoid failures. # Introduction This is an API documentation for TestCollab 2.   # Authentication TestCollab supports two forms of authentication:   - An <b>API token</b> is required to make API calls. The token can be generated from user's profile; to obtain it login to your TestCollab account and go to ['My Profile Settings'](https://testcollab.io/my_profile) and switch to API Token tab. Click on \"Generate new API token\", Once the token is generated it can be sent as a query parameter for the API calls made - https://api.testcollab.io/projects?token=<generated-API-token>    - <b>Bearer authentication</b> (also called token authentication) is an HTTP authentication scheme that involves security tokens called bearer tokens. You can generate bearer auth token using [Login](#operation/login) API.     Send this token as the Authorization header while making requests to protected resources:     `Authorization: Bearer <token>`    For making API calls, we recommend using the <b>API token</b> generated from user profile page as it won't affect the on-going user session and will be available until it is revoked by the user who generated it.      # Error Handling Error responses   - `Not Found` - Error is sent when requested resource is not available.   - `Unauthorized - invalid token` - Error is sent when API token sent with the request is invalid or revoked. Error contains status code 401        - `Forbidden` - Error is sent when logged in user is not part of the company, project or his role does not allow to complete given action. Response consist of 403 status code and more information is given in error message.
 *
 * OpenAPI spec version: 2.3.1
 * Contact: support@testcollab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from "../runtime";
/**
 * A defect raised against one of the build's test plans (TCV-6726).
 * @export
 * @interface BuildDefect
 */
export interface BuildDefect {
  /**
   *
   * @type {number}
   * @memberof BuildDefect
   */
  id: number;
  /**
   * Identifier in the connected issue manager or built-in tracker (e.g. ISS-214).
   * @type {string}
   * @memberof BuildDefect
   */
  externalId?: string;
  /**
   *
   * @type {string}
   * @memberof BuildDefect
   */
  title: string;
  /**
   * Internal defect status code.
   * @type {string}
   * @memberof BuildDefect
   */
  status?: string;
  /**
   * Human-readable status label from the issue manager (e.g. To Do, Closed).
   * @type {string}
   * @memberof BuildDefect
   */
  defectStatus?: string;
  /**
   * The issue manager the defect was pushed to (e.g. inbuilt, jira, azuredevops).
   * @type {string}
   * @memberof BuildDefect
   */
  issueManager?: string;
  /**
   * Link to the defect in the issue manager.
   * @type {string}
   * @memberof BuildDefect
   */
  defectUrl?: string;
  /**
   * The build test plan the defect was found in.
   * @type {number}
   * @memberof BuildDefect
   */
  testPlan?: number;
  /**
   *
   * @type {string}
   * @memberof BuildDefect
   */
  testPlanTitle?: string;
  /**
   * The test case the defect was raised from.
   * @type {number}
   * @memberof BuildDefect
   */
  testcase?: number;
  /**
   * Per-company business number of the test case (rendered as TC-<n>).
   * @type {number}
   * @memberof BuildDefect
   */
  testcaseDisplayNumber?: number;
}

export function BuildDefectFromJSON(json: any): BuildDefect {
  return {
    id: json["id"],
    externalId: !exists(json, "external_id") ? undefined : json["external_id"],
    title: json["title"],
    status: !exists(json, "status") ? undefined : json["status"],
    defectStatus: !exists(json, "defect_status")
      ? undefined
      : json["defect_status"],
    issueManager: !exists(json, "issue_manager")
      ? undefined
      : json["issue_manager"],
    defectUrl: !exists(json, "defect_url") ? undefined : json["defect_url"],
    testPlan: !exists(json, "test_plan") ? undefined : json["test_plan"],
    testPlanTitle: !exists(json, "test_plan_title")
      ? undefined
      : json["test_plan_title"],
    testcase: !exists(json, "testcase") ? undefined : json["testcase"],
    testcaseDisplayNumber: !exists(json, "testcase_display_number")
      ? undefined
      : json["testcase_display_number"],
  };
}

export function BuildDefectToJSON(value?: BuildDefect): any {
  if (value === undefined) {
    return undefined;
  }
  return {
    id: value.id,
    external_id: value.externalId,
    title: value.title,
    status: value.status,
    defect_status: value.defectStatus,
    issue_manager: value.issueManager,
    defect_url: value.defectUrl,
    test_plan: value.testPlan,
    test_plan_title: value.testPlanTitle,
    testcase: value.testcase,
    testcase_display_number: value.testcaseDisplayNumber,
  };
}
